import { Highlight, SearchItem } from '../types';

export const attachHighlighting = (items: SearchItem[], highlighting?: Highlight): SearchItem[] => {
	// `items` is typed non-optional but both call sites reach it through optional chaining, so guard.
	if (!highlighting || !items?.length) {
		return items;
	}

	return items.map((item) => {
		const highlight = highlighting[item.id];

		return highlight ? { ...item, highlight } : item;
	});
};
